export const DELIVERY_SHUT_REQUEST_UPDATE = 'DELIVERY_SHUT_REQUEST_UPDATE'
export const DELIVERY_SHUT_REQUEST = 'DELIVERY_SHUT_REQUEST'
export const DELIVERY_SHUT_SUCCESS = 'DELIVERY_SHUT_SUCCESS'
export const DELIVERY_SHUT_FALIURE = 'DELIVERY_SHUT_FALIURE'
